import './icon-component.scss';
import { bridgeWarAssets } from '../../assets/bridgewars';
import React, { useEffect, useRef, useState } from 'react';

const svgCache = new Map<string, string>();
const pendingFetches = new Map<string, Promise<string>>();

const iconNames = ['attacker', 'defender', 'compass', 'south', 'east', 'west', 'north'];

(function preloadIcons() {
    const { domain, iconsFolder } = bridgeWarAssets.config;
    iconNames.forEach(icon => {
        const iconUrl = `${domain}/${iconsFolder}/${icon}.svg`;
        if (!svgCache.has(iconUrl)) {
            const fetchPromise = fetch(iconUrl)
                .then(res => res.text())
                .then(svg => {
                    svgCache.set(iconUrl, svg);
                    return svg;
                })
                .catch(() => {
                    svgCache.set(iconUrl, '');
                    return '';
                });
            pendingFetches.set(iconUrl, fetchPromise);
        }
    });
})();

type IconComponentProps = {
    icon: string;
};

export const IconComponent: React.FC<IconComponentProps> = ({ icon }) => {
    const { domain, iconsFolder } = bridgeWarAssets.config;
    const iconUrl = `${domain}/${iconsFolder}/${icon}.svg`;

    const containerRef = useRef<HTMLSpanElement>(null);
    const [svgString, setSvgString] = useState<string | null>(() => svgCache.get(iconUrl) || null);

    useEffect(() => {
        if (svgString !== null) {
            return;
        }

        const loadSvg = async () => {
            if (svgCache.has(iconUrl)) {
                setSvgString(svgCache.get(iconUrl)!);
            } else {
                const svg = await fetch(iconUrl).then(res => res.text()).catch(() => '');
                svgCache.set(iconUrl, svg);
                setSvgString(svg);
            }
        };

        loadSvg();
    }, [iconUrl, svgString]);

    useEffect(() => {
        if (!svgString || !containerRef.current) {
            return;
        }

        // Clear previous SVG
        containerRef.current.innerHTML = '';

        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(svgString, 'image/svg+xml');
        const svgElement = svgDoc.documentElement;

        containerRef.current.appendChild(svgElement);
    }, [svgString]);

    return <span className="IconComponent" ref={containerRef} />;
};
